export default __webpack_public_path__ + "cf6d9d477e1de45c8c3a3b8fe6c5980b.png";